module.exports = __webpack_public_path__ + "img/how-to-2.c00148c1.png";